// CMS and public website use the exact same versioned renderer.
const runtime = require('./bannerRuntime');
export const previewDocument = runtime.previewDocument;
